import React from 'react';
import {Button} from "@mui/material";
import {useStyles} from "./AppButton.css";

const AppButton = ({label, icon, variant="contained", ...props}) => {
    const classes = useStyles();

    return (
        <Button className={classes.button} type="submit" fullWidth variant={variant} color="primary" {...props}>
            <div className={classes.extendedIcon}>
                {icon}
            </div>
            {label}
        </Button>
    )
}

export default AppButton
